import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';
import {SortDirection as SortDirections} from 'src/openapi/admin/models/SortDirection';

import type {McpLimitLogCriteria} from '../typedef';
import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';

export const MCP_LIMIT_LOG_SORT_FIELDS = {
    TIMESTAMP: 'timestamp',
} as const;

export type McpLimitLogSortField = typeof MCP_LIMIT_LOG_SORT_FIELDS[keyof typeof MCP_LIMIT_LOG_SORT_FIELDS];

export const mcpLimitLogStateSlice = getCachedTableStateSlice<
    undefined,
    McpLimitLogSortField,
    McpLimitLogCriteria
>('mcpLimitLogState', MCP_LIMIT_LOG_SORT_FIELDS.TIMESTAMP, {pageSize: 25, currentPage: 1}, SortDirections.DESC);

export const mcpLimitLogStateActions = mcpLimitLogStateSlice.actions;
export const mcpLimitLogStateSelector: CachedTableStateSelector<
    undefined,
    McpLimitLogSortField,
    McpLimitLogCriteria
> = state => state.accountPage.tabs.licenseAndFeatures.mcpLimitLog.state;
